<template>
    <button-icon-popover
        :button-class-name="[
            'border-gray-200 divide-x divide-gray-200 py-3',
            'w-14 md:w-18',
            'transition-all duration-300',
            position === 'right' && 'border-l last:rounded-tr-lg',
            position === 'left' && 'border-r last:rounded-tl-lg',
            buttonClassName,
        ]"
        :button-test-id="buttonTestId"
        :disabled="disabled"
        :icon-name="iconName"
        :icon-class-name="iconClassName"
        :icon-size-class-name="iconSizeClassName"
        :indicator="indicator"
        :indicator-class-name="indicatorClassName"
        :indicator-type="indicatorType"
        :tooltip="tooltip"
        @click="$emit('click')"
    >
        <template #popoverContent="{ closePopover }" v-if="$slots.popoverContent">
            <slot name="popoverContent" :close-popover="closePopover" />
        </template>
    </button-icon-popover>
</template>

<script>
    import ButtonIconPopover, {
        indicatorTypes,
    } from '@/components/presentational/ButtonIconPopover.vue';

    export default {
        emits: ['click'],

        components: { ButtonIconPopover },

        props: {
            buttonClassName: {
                type: [String, Array, Object],
                default: '',
            },
            buttonTestId: {
                type: String,
                default: null,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            iconClassName: {
                type: [String, Array, Object],
            },
            iconName: {
                type: String,
            },
            indicator: {
                type: Boolean,
                default: false,
            },
            indicatorClassName: {
                type: [String, Array, Object],
                default: '',
            },
            iconSizeClassName: {
                type: [String, Array, Object],
                default: 'text-xl',
            },
            indicatorType: {
                type: String,
                default: 'info',
                validator: (value) => indicatorTypes.includes(value),
            },
            tooltip: {
                type: String,
                default: '',
            },
            position: {
                type: String,
                default: 'right',
                validator: (value) => ['left', 'right'].includes(value),
            },
        },
    };
</script>
